function attachClickListener() {
  var continueButton = document.getElementById('continue_button');
  if (continueButton) {
    continueButton.removeEventListener('click', handleButtonClick); // To ensure we do not add multiple listeners
    continueButton.addEventListener('click', handleButtonClick);
    return true;  // Listener attached successfully.
  }
  return false;  // Listener could not be attached.
}

function handleButtonClick(event) {
  var shippingAddressField1 = document.querySelector('#checkout_shipping_address_address1');
  var shippingAddressField2 = document.querySelector('#checkout_shipping_address_address2');
  var poBoxRegex = /(P(\.|O(\.|st)?)?(\s+B(ox)?)?)\s+\d+/i;
  if ((shippingAddressField1 && poBoxRegex.test(shippingAddressField1.value)) || 
      (shippingAddressField2 && poBoxRegex.test(shippingAddressField2.value))) {
    alert('No PO Boxes allowed. Please update your shipping address.');
    event.preventDefault();
    return;
  }

  var billingAddressField1 = document.querySelector('#checkout_billing_address_address1');
  var billingAddressField2 = document.querySelector('#checkout_billing_address_address2');
  if ((billingAddressField1 && poBoxRegex.test(billingAddressField1.value)) || 
      (billingAddressField2 && poBoxRegex.test(billingAddressField2.value))) {
    alert('No PO Boxes allowed. Please update your billing address.');
    event.preventDefault();
    return;
  }

  var billingCountrySelect = document.querySelector('select[name="checkout[billing_address][country]"]');
  if (billingCountrySelect && billingCountrySelect.value !== 'United States') {
    alert('Only US billing addresses are allowed.');
    event.preventDefault();
  }
}

var shippingStep = 'step=contact_information';
var isShippingStep = window.location.href.indexOf(shippingStep) !== -1;
if (isShippingStep) {
  var preventpo_intervalId = setInterval(function() {
    if (attachClickListener()) {
      clearInterval(preventpo_intervalId);
    }
  }, 100);
}

var billingStep = 'step=payment_method';
var isBillingStep = window.location.href.indexOf(billingStep) !== -1;
if (isBillingStep) {
  var preventpo_intervalId = setInterval(function() {
    if (attachClickListener()) {
      clearInterval(preventpo_intervalId);
    }
  }, 100);
}

var preventpo_intervalId = setInterval(function() {
  if (attachClickListener()) {
    clearInterval(preventpo_intervalId);
  }
}, 100);
